import { FunctionalComponent, h } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { SchemaName } from '@cewe-onsitesearch/schemas';
import { OnsiteSearchComponent } from '../../cwc-onsite-search';

/**
 * Definition of  parameters that the template needs to work.
 */
interface JumpLinksTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: OnsiteSearchComponent;
  order: SchemaName[];
  // Specify parameters that are required to be passed down to the template here.
}

const JumpLinksTemplate: FunctionalComponent<JumpLinksTemplateProps> = ({ controller, order }) => {
  if (!controller.searchResponse || Object.keys(controller.searchResponse.results).length === 0) {
    return '';
  }

  // @TODO: move outside of jumplinks and inject from outside
  const activeTabNames = [
    SchemaName.product,
    controller.breakPoints.breakpointDown('sm') ? SchemaName.category : undefined,
    SchemaName.inspiration,
    SchemaName.service,
    SchemaName.page,
  ];
  const totalResults: number = activeTabNames.reduce(
    (acc: number, tabName) => acc + Number(controller.searchResponse.results?.[tabName]?.hits.length ?? 0),
    0,
  );

  const orderedTabNames: SchemaName[] = (order ?? []).filter((tabName) => activeTabNames.includes(tabName));

  if (totalResults <= 0) {
    return '';
  }

  return (
    <jump-links>
      <span>
        {totalResults}{' '}
        {totalResults === 1
          ? controller.textResources.results.totalResult
          : controller.textResources.results.totalResults}
      </span>
      {orderedTabNames.map((tabName) => {
        const count = controller.searchResponse.results?.[tabName]?.hits.length ?? 0;
        if (count > 0) {
          return (
            <a data-tabname={tabName} onClick={() => controller.onTagClick(tabName)}>
              {controller.textResources.results?.[tabName].headline}
              <svg viewBox="0 0 24 24">
                <g class="active">
                  <circle cx="12" cy="12" r="11.5" />
                  <path d="M20.21,6.29a1,1,0,0,0-1.42,0L9.5,15.59l-4.29-4.3a1,1,0,0,0-1.42,1.42l5,5a1,1,0,0,0,1.42,0l10-10A1,1,0,0,0,20.21,6.29Z" />
                </g>
                <g class="count">
                  <circle cx="12" cy="12" r="12" />
                  <text x="50%" y="55%" text-anchor="middle" dominant-baseline="middle">
                    {count}
                  </text>
                </g>
              </svg>
            </a>
          );
        }
        return '';
      })}
    </jump-links>
  );
};

export default JumpLinksTemplate;
